import { YPaymentAmount } from '../y/amount';
import { $api } from '../y/api';
import { YLanguage } from '../y/i18n';
import { YId, YCountryId, YTimeString } from '../y/types';
import { CPlan } from './c-plan';
import { CPaidPlanId, CPlanId } from './c-user';

export interface UPostalAddress {
    name: string;
    address: string;
    post_code: string;
    city: string;
}

export interface PGiftcard {
    id: YId;
    code: string;
    country: YCountryId;
    expires: YTimeString;
    plan: CPlanId;
    months: number;
    is_test: boolean;
    is_redeemed: boolean;
    is_voided: boolean;
    is_delivered: boolean;
    redeem_user_id?: YId;
    buyer_name: string;
    buyer_email: string;
    language: YLanguage;
    texts?: { to: string, from: string };
    delivery_address?: UPostalAddress;
    influencer?: string;
    batch?: string;
    created_at: YTimeString;
}

export interface PGiftcardAdminView extends PGiftcard {
    redeem_user_email?: string;
}

export interface PGiftcardPlans {
    plans: CPlan[];
    pricing: { [kind in CPaidPlanId]: { [months: number]: YPaymentAmount } };
    base_price: { [kind in CPaidPlanId]: YPaymentAmount };
    code?: string;
    post: boolean;
}

let all_giftcards_promise: Promise<PGiftcardAdminView[]> | undefined;
export function pGiftcardsGetAll() {
    if(!all_giftcards_promise) {
        all_giftcards_promise = $api.GET<PGiftcardAdminView[]>('p/giftcards/admin_view');
    }

    return all_giftcards_promise;
}

export function pGiftcardUpdate(id: YId, data: any) {
    return $api.PUT<PGiftcard>(`p/giftcard/${id}`, data);
}

export function pGiftcardVoid(id: YId) {
    return $api.DELETE(`p/giftcard/${id}`);
}

export function pGiftcardGetTransactions(id: YId) {
    return $api.GET(`p/giftcard/${id}/transactions`);
}

export function pGiftcardDelivered(id: YId) {
    return $api.POST(`p/giftcard${id}/delivered`);
}

export function pGiftcardsGenerate(params: any) {
    return $api.POST('p/giftcards', params);
}
